export default {
  /**
   * 文字列をスネークケースからキャメルケースに変換する
   * @param {*} str 変換対象の文字列
   * @returns キャメルケースに変換した文字列
   */
  toCamelCase: function (str) {
    return str
      .split('_')
      .map(function (word, index) {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  },
  /**
   * オブジェクトをスネークケースからキャメルケースに変換する
   * @param {*} obj 変換対象のオブジェクト
   * @returns キャメルケースに変換したオブジェクト
   */
  toCamelCaseForObject: function (obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      result[this.toCamelCase(key)] = obj[key];
    });
    return result;
  },
  /**
   * 日本円表記に変換する
   * @param {*} price
   * @returns
   */
  toJpy: function (price) {
    var s = String(price).split('.');
    var ret = String(s[0]).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    if (s.length > 1) {
      ret += '.' + s[1];
    }
    return `¥${ret}`;
  },
  /**
   * 未入力文字列に変換する（文字列用）
   * @param {*} value
   */
  toConfirmationLabelForDate: function (year, month, day) {
    if (!year || !month || !day) return '(未入力)';
    // if (year === '' || month === '' || day === '') return '(未入力)';
    return `${year}年${month}月${day}日`;
  },
  /**
   * 未入力文字列に変換する（文字列用）
   * @param {*} value
   */
  toConfirmationLabelForString: function (value) {
    return value ? value : '(未入力)';
  },
  /**
   * 文字列をキャメルケースからスネークケースに変換する
   * @param {*} str 変換対象の文字列
   * @returns スネークケースに変換した文字列
   */
  toSnakeCase: function (str) {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase();
  },
  /**
   * オブジェクトをキャメルケースからスネークケースに変換する
   * @param {*} obj 変換対象のオブジェクト
   * @returns スネークケースに変換したオブジェクト
   */
  toSnakeCaseForObject: function (obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      result[this.toSnakeCase(key)] = obj[key];
    });
    return result;
  },
};
